<template>
  <footer class="site-footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3 class="footer-title">友情链接</h3>
        <div class="footer-links">
          <a v-for="link in friendLinks" :key="link.url"
            :href="isWxMini ? undefined : link.url"
            target="_blank" rel="noopener noreferrer"
            @click="handleLinkClick(link.url, $event)"
          >{{ link.name }}</a>
        </div>
      </div>
      
      <div class="footer-section">
        <h3 class="footer-title">联系我们</h3>
        <div class="contact-info">
          <p><i class="el-icon-message"></i> 邮箱：<a href="mailto:lovejavasmd@163.com">lovejavasmd@163.com</a></p>
          <p><i class="el-icon-phone"></i> 技术支持：15810337728</p>
        </div>
      </div>
      
      <div class="footer-section">
        <h3 class="footer-title">关于我们</h3>
        <p class="company-desc">北京利康科技有限公司专注保健食品行业，提供专业的批文转让、清理换证、注册备案及研发服务。</p>
      </div>
    </div>
    
    <div class="footer-bottom">
      <div class="footer-legal">
        <a :href="isWxMini ? undefined : 'https://beian.mps.gov.cn/#/query/webSearch?code=11010602201723'"
          rel="noreferrer" target="_blank" class="beian-link"
          @click="handleLinkClick('https://beian.mps.gov.cn/#/query/webSearch?code=11010602201723', $event)"
        >
          <img src="./备案图标.png" alt="公安备案图标" class="beian-icon">京公网安备11010602201723号
        </a>
        <span class="divider">|</span>
        <a :href="isWxMini ? undefined : 'https://beian.miit.gov.cn/#/Integrated/index'"
          target="_blank" rel="noopener noreferrer"
          @click="handleLinkClick('https://beian.miit.gov.cn/#/Integrated/index', $event)"
        >京ICP备2025130057号-1</a>
      </div>
      <p class="copyright">© 2025 北京利康科技有限公司 版权所有</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MyFooter',
  data() {
    return {
      isWxMini: /miniProgram/i.test(navigator.userAgent),
      friendLinks: [
        { name: '国家市场监督总局', url: 'https://www.samr.gov.cn' },
        { name: '国家市场监督总局食品审评中心', url: 'https://www.cfsi.net.cn/' },
        { name: '食品伙伴网', url: 'https://www.foodmate.net/' },
        { name: '国家知识产权局', url: 'https://www.cnipa.gov.cn/' },
        { name: '保健食品注册管理信息系统', url: 'https://xbjspzc.gsxt.gov.cn/regist_enter/' }
      ]
    }
  },
  methods: {
    handleLinkClick(url, event) {
      if (this.isWxMini) {
        event.preventDefault()
        this.copyToClipboard(url)
      }
    },
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          alert('链接已复制到剪贴板，请在浏览器中打开：\n' + text)
        }).catch(() => {
          this.fallbackCopy(text)
        })
      } else {
        this.fallbackCopy(text)
      }
    },
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        alert('链接已复制到剪贴板，请在浏览器中打开：\n' + text)
      } catch (e) {
        alert('请长按链接复制：' + text)
      }
      document.body.removeChild(textarea)
    }
  }
}
</script>

<style scoped>
.site-footer {
  background: linear-gradient(135deg, #1a2a3a 0%, #2c3e50 100%);
  color: #ecf0f1;
  padding: 0;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px 30px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
}

.footer-section {
  text-align: left;
}

.footer-title {
  color: #3498db;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #3498db;
  display: inline-block;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-links a {
  color: #bdc3c7;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  padding: 5px 0;
}

.footer-links a:hover {
  color: #3498db;
  padding-left: 10px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact-info p {
  color: #bdc3c7;
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-info a {
  color: #3498db;
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-info a:hover {
  color: #5dade2;
}

.company-desc {
  color: #bdc3c7;
  font-size: 14px;
  line-height: 1.8;
  margin: 0;
}

.footer-bottom {
  background: rgba(0, 0, 0, 0.2);
  padding: 20px;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-legal {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 10px;
}

.footer-legal a {
  color: #95a5a6;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s ease;
}

.footer-legal a:hover {
  color: #3498db;
}

.beian-link {
  display: flex;
  align-items: center;
  gap: 5px;
}

.beian-icon {
  height: 16px;
  width: auto;
}

.divider {
  color: #7f8c8d;
}

.copyright {
  color: #7f8c8d;
  font-size: 12px;
  margin: 0;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 30px 15px 20px;
  }
  
  .footer-section {
    text-align: center;
  }
  
  .footer-title {
    display: block;
  }
  
  .footer-links a:hover {
    padding-left: 0;
  }
  
  .contact-info p {
    justify-content: center;
  }
  
  .footer-legal {
    flex-direction: column;
    gap: 10px;
  }
  
  .divider {
    display: none;
  }
}

@media (min-width: 1200px) {
  .footer-content {
    padding: 50px 40px 40px;
  }
}
</style>
